interface IPOMIS_FORMULA {
  amount: number;
  rate: number;
}
export const POMIS_FORMULA = ({ amount, rate }: IPOMIS_FORMULA) => {
  if (amount < 1000 || amount > 45e4) {
    const emptyRes = 0;
    return {
      interest: emptyRes.toFixed(2),
    };
  }
  const principal = amount;
  const interestRate = rate;

  const pomis = (principal * interestRate) / 1200;
  return {
    interest: pomis.toFixed(2),
  };
};
